import { Button } from 'shared/ui'
import { useCopyToClipboard } from 'shared/hooks/useCopyToClipboard'

type IWebhookCopyButtonProps = {
  url: string
}

export const WebhookCopyButton = ({ url }: IWebhookCopyButtonProps) => {
  const { onCopy, copied } = useCopyToClipboard(url)

  const dynamicProps = copied
    ? ({
        text: 'Copied',
      } as const)
    : ({
        text: 'Copy URL',
        icon: 'copy',
        iconProps: {
          padding: '4px 0',
        },
      } as const)

  return <Button disabled={!url} onClick={onCopy} fullWidth {...dynamicProps} />
}
